import {AfterContentInit, Component, ContentChildren} from '@angular/core';
import {SlideDirective} from './slide/slide.directive';
import {BreakpointObserver} from '@angular/cdk/layout';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'ds-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements AfterContentInit {

  @ContentChildren(SlideDirective) slides;
  width: number;
  position: number = 0;
  visibleSlides: number = 4;

  constructor(private breakpointObserver: BreakpointObserver) {
  }

  ngAfterContentInit(): void {
    this.width = this.slides.length > 3 ? 25 : Math.floor(100 / this.slides.length);
    this.observeBreakpoints();
  }

  navigate(direction: number): void {
    this.position += direction;
  }

  observeBreakpoints() {
    const sm = '(max-width: 48em)'; // 1 slide shown
    const md = '(min-width: 48em)'; // 2 slides shown
    const lg = '(min-width: 61.25em)'; // 3 slides shown
    const xl = '(min-width: 81.25em)'; // 4 slides shown
    this.breakpointObserver.observe([sm, md, lg, xl]).pipe(untilDestroyed(this))
      .subscribe(({breakpoints}) => {
        let hiddenSlides: number = 0;
        if (breakpoints[xl]) {
          hiddenSlides = 0;
        } else if (breakpoints[lg]) {
          hiddenSlides = 1;
        } else if (breakpoints[md]) {
          hiddenSlides = 2;
        } else if (breakpoints[sm]) {
          hiddenSlides = 3;
        }
        this.visibleSlides = 4 - hiddenSlides;
      });
  }
}
